<template>
  <div class="card-body">
    <div class="row">
      <div class="col-12" style="max-width: 95%; margin: auto;">
        <h4 class="card-title text-purple">{{ $t('app.modules.order_model.title') }}</h4>

        <div class="row" v-for="(pedido, index) in pedidos" :key="'ped-'+index">
          <div class="col-12">
            <div class="card">
              <div class="card-header card-header-custom">
                <div class="row">
                  <div class="col-10">
                    <label>{{ $t('app.modules.order_model.headers.order_model') }}:</label>
                    <h5>{{ pedido.nombre }}</h5>
                  </div>
                  <div class="col-2">
                    <button style="background-color: #e71e26; color: white; border: none; font-weight: bold;" @click="addProducto(index)">{{ $t('app.modules.order_model.buttons.use_order_model') }}</button>
                  </div>
                </div>
              </div>
              <div class="card-body" v-for="(item, ind) in pedido.items">
                <div class="row">
                  <div class="col-1"><img class="icon-image"  alt="" :src="item.productoCliente.familia.icon"></div>
                  <div class="col-2">
                    <div class="form-group">
                      <strong>{{ item.productoCliente.familia.productoPadre }}</strong>
                    </div>
                    <div class="form-group">
                      <label>{{ item.productoCliente.familia.descripcion }}</label>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="form-group">
                      <fg-input
                        type="number"
                        :placeholder="$t('app.modules.order_model.headers.quantity')"
                        :label="$t('app.modules.order_model.headers.quantity') + ' (' + item.productoCliente.unidadMedida + ')' "
                        v-model="item.cantidad"
                      >
                      </fg-input>
                    </div>
                    <div class="form-group">
                      <fg-input
                        type="text"
                        :placeholder="$t('app.modules.order_model.headers.unit_price')"
                        :label="$t('app.modules.order_model.headers.unit_price') + ' (' + item.productoCliente.moneda + ')'"
                        disabled
                        :value="item.productoCliente.precioUnitario"
                      >
                      </fg-input>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <fg-input
                        type="text"
                        :placeholder="$t('app.modules.order_model.headers.delivery_address')"
                        :label="$t('app.modules.order_model.headers.delivery_address')"
                        disabled
                        :value="item.productoCliente.direccionEntrega"
                      >
                      </fg-input>
                    </div>
                    <div class="form-group">
                      <label>{{ $t('app.modules.order_model.headers.delivery_date') }}</label>
                      <el-date-picker v-model="item.fechaEntrega" format="dd-MM-yyyy" type="date"/>
                    </div>
                  </div>
                  <div class="col-2">
                    <label style="width: 100%">{{ $t('app.modules.order_model.headers.amount') }}</label>
                    <h4 style="display: inline-block; margin-top: 0">{{ subtotal(index, ind).toFixed(4).replace('.0000', '') }}</h4>
                    <label style="margin-left: 4px">{{ item.productoCliente.moneda }}</label>
                  </div>
                  <div class="col-2" v-if="ind === pedido.items.length-1">
                    <div class="card" style="background-color: #e71e26; color: white">
                      <div class="card-body">
                        <h4 style="margin-top: 0">{{ $t('app.modules.order_model.headers.subtotal') }}</h4>
                        <h4 style="margin-top: 0; display: inline-block">{{ total(index).toFixed(4).replace('.0000', '') }}</h4>
                        <label style="color: white !important; margin-left: 4px; font-size: 14px; font-weight: bold">{{ item.productoCliente.moneda }}</label>
                        <label style="width: 100%; text-align: right; color: white !important; font-size: 14px; font-weight: bold">{{ $t('app.modules.order_model.headers.without_iva') }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!item.productoCliente.publicado"><label style="color: #e71e26">Producto no disponible</label></div>
                <div class="separate" style="background-color: #E3E3E3; height: 1px; width: 100%" v-if="ind < pedido.items.length-1"></div>
              </div>
              <div class="row">
                <div class="col-12" style="text-align: right">
                  <button style="background-color: transparent; color: #e71e26; border: none; font-weight: bold;" @click="deletePedido(index)">{{ $t('app.modules.order_model.buttons.remove_order_model') }}</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getResponse} from "@/util/utilities";
import Swal from "sweetalert2";

export default {
  name: "pedidosModelo",
  data() {
    return {
      pedidos: []
    }
  },
  mounted() {
    this.getPedidosModelo();
  },
  methods: {
    async getPedidosModelo(){
      this.pedidos = [];
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      let request = await this.$http.post(route("Pedidos/pedidosModeloByUser"));
      let response = getResponse(request, null);

      if(response){
        let pedidos = response.pedidosModelo;
        pedidos.forEach(p => {
          let pedido = {
              nombre: p.nombre,
              idPedidoModelo: p.idPedidoModelo,
              items: []
          }

          if(p.itemsPedidoModelo.length > 0){

            var fechatest = new Date();
            fechatest.setDate(fechatest.getDate() + 30)

            p.itemsPedidoModelo.forEach(i => {
              let itemPedidoModelo = i;
              let item = {
                cantidad: itemPedidoModelo.cantidad,
                productoCliente: null,
                idProductoCliente: itemPedidoModelo.idProductoCliente,
                fechaEntrega : fechatest
              }

              if(itemPedidoModelo.productoCliente != null){
                let productoCliente = itemPedidoModelo.productoCliente;
                let direccion = productoCliente.direccionEntrega;

                item.productoCliente = {
                  unidadMedida: productoCliente.unidadMedida,
                  moneda: productoCliente.moneda,
                  precioUnitario: productoCliente.precioUnitario,
                  direccionEntrega: direccion != null ? direccion.direccionString : "",
                  familia: null,
                  publicado: productoCliente?.producto?.publicado
                }

                let familia = productoCliente.producto !== null && productoCliente.producto.familiaProducto !== null ? productoCliente.producto.familiaProducto : null;

                if(familia != null){
                  let trad = familia.traducciones.filter(t => t.idioma.clave === this.$store.state.lang);
                  let fam = {
                    productoPadre: familia.productoPadre,
                    descripcion: trad.length > 0 ? trad[0].descripcion : "",
                    icon: ""
                  }

                  if(!!familia.iconografia){
                    let icons = familia.iconografia;
                    let json = JSON.parse(icons);
                    if(json.length > 0){
                      fam.icon = json[0];
                    }
                  }
                  item.productoCliente.familia = fam;
                }

              }

              pedido.items.push(item);
            });
          }

          this.pedidos.push(pedido);
        });
      }

      this.$swal.close();
    },
    addProducto(index){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try{
        let pedido = this.pedidos[index];

        let items = [];
        pedido.items.forEach(i => {
          if(i.productoCliente.publicado){
            let payload = {idProductoCliente: i.idProductoCliente, cantidad: i.cantidad, fechaEntrega: i.fechaEntrega};

            if(!payload.idProductoCliente) throw new Error(this.$t("app.modules.product_family_detail.errors.no_client"));
            if(!payload.cantidad) throw new Error(this.$t("app.modules.product_family_detail.errors.no_quantity"));
            if(!payload.fechaEntrega) throw new Error(this.$t("app.modules.product_family_detail.errors.no_delivery_date"));

            items.push(payload);
          }
        });

        items.forEach(i => {
          EventBus.$emit("add-to-cart", i);
        });
      }
      catch (e){
        this.notifyMessage("danger", e.message);
      }
      finally {
        this.$swal.close();
      }
    },
    total(index){
      return this.pedidos[index].items.reduce((acum, current) => {return acum + (current.cantidad * current.productoCliente.precioUnitario);}, 0);
    },
    subtotal(index, ind){
      return this.pedidos[index].items[ind].cantidad * this.pedidos[index].items[ind].productoCliente.precioUnitario;
    },
    confirmarEliminar(){
      return Swal.fire({
        text: this.$t("app.promps.delete"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: this.$t("app.cart.messages.confirm_order_button"),
        cancelButtonText: this.$t("app.buttons.cancel"),
        buttonsStyling: false
      });
    },
    async deletePedido(index){
      let confirmOrder = await this.confirmarEliminar();

      if(confirmOrder.isConfirmed){
        this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });

        let request = await this.$http.post(route("Pedidos/removePedidoModelo"), {id: this.pedidos[index].idPedidoModelo});
        let response = getResponse(request, null);

        if(response){
          this.getPedidosModelo();
          this.notifyMessage("success", this.$t("app.promps.save_success"));
        }
        else this.notifyMessage("danger", this.$t("app.promps.error"));

        this.$swal.close();
      }
    }
  }
}
</script>

<style scoped>
.card-header-custom {
  background-color: #bebcba !important;
  border-radius: 10px 10px 0 0 !important;
  padding: 24px 10px !important;
}
.card-header > div > div > label {
  color: black;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
}
.card-header > div > div > h5 {
  color: white;
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  margin-left: 4px;
  margin-bottom: 0;
}
.icon-image {
  width: 100% !important;
  border-radius: 0 !important;
}
</style>
